module.exports = __webpack_public_path__ + "img/face-laugh.91b86fd3.svg";